<template>
  <div>
    <el-card shadow="never" class="aui-card--fill">
      <el-form :model="dataForm" ref="dataForm">
      <el-col :span="6">
        <el-form-item label="培训id" prop="trainingId">
          <label>：&#12288;{{dataForm.trainingId}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="用户ID" prop="userId">
          <label>：&#12288;{{dataForm.userId}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="培训url" prop="trainingUrl">
          <label>：&#12288;{{dataForm.trainingUrl}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="培训标题" prop="trainingTitle">
          <label>：&#12288;{{dataForm.trainingTitle}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="创建时间" prop="createTime">
          <label>：&#12288;{{dataForm.createTime}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="创建者编号" prop="createUser">
          <label>：&#12288;{{dataForm.createUser}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="更新时间" prop="updateTime">
          <label>：&#12288;{{dataForm.updateTime}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="更新者编号" prop="updateUser">
          <label>：&#12288;{{dataForm.updateUser}}</label>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="删除标记" prop="delFlag">
          <label>：&#12288;{{dataForm.delFlag}}</label>
        </el-form-item>
      </el-col>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        userTrainingId: 0,
        trainingId: '',
        userId: '',
        trainingUrl: '',
        trainingTitle: '',
        createTime: '',
        createUser: '',
        updateTime: '',
        updateUser: '',
        delFlag: ''
      }
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs['dataForm'].resetFields()
      if (this.$route.query.userTrainingId !== undefined) {
        this.dataForm.userTrainingId = this.$route.query.userTrainingId
        this.getInfo()
      }
    })
  },
  methods: {
    // 获取信息
    getInfo () {
      this.$request.get(`/sys/commusertraining/info/${this.dataForm.userTrainingId}`).then((data) => {
        this.dataForm.trainingId = data.trainingId
        this.dataForm.userId = data.userId
        this.dataForm.trainingUrl = data.trainingUrl
        this.dataForm.trainingTitle = data.trainingTitle
        this.dataForm.createTime = data.createTime
        this.dataForm.createUser = data.createUser
        this.dataForm.updateTime = data.updateTime
        this.dataForm.updateUser = data.updateUser
        this.dataForm.delFlag = data.delFlag
      })
    },
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
</style>
